/* Package JSON Import will be here */
import React, { Fragment, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import 'rc-tooltip/assets/bootstrap_white.css';
import { Header, Icon, Menu, Segment, Sidebar, Card, Feed, Button, Divider, Dropdown } from 'semantic-ui-react';
import { useMediaQuery } from 'react-responsive'
/* Package JSON Import will be here */

/* Project Import will be here */
import * as actions from '../../actions/login.Action';
import './Layout.css';
import '../../assets/styles/styles.css';
import { Constants } from '../../config/appConstants';
import packageJson from '../../../package.json';
/* Project Import will be here */

const Layout = (props) => {
    const isMobile = useMediaQuery({ query: '(max-width: 736px)' });
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
    const [visible, setVisible] = useState(isMobile && isPortrait ? false : true);

    const handleLogout = () => {
        setVisible(!visible);
        props.logout();
        // if (props.user.roleName === Constants.SYSTEM_ADMIN_ROLE_NAME || !configSettings.isAllowSSOLogin) {
        //     setVisible(!visible);
        //     props.logout();
        // }
        // else {
        //     let url = ApiUrls.Routes.SSLOT_M + ApiUrls.Routes.SSLOT_M;
        //     Api.Post(url, {}, { props }).then((responseData) => {
        //         if (responseData.success) {
        //             setVisible(!visible);
        //             props.logout();
        //         }
        //     });
        // }
    }

    return (
        <Fragment>
            <Header as='div' block style={{ height: '45px' }}>
                <div className="leftUserName text-color">
                    <Button basic={true} icon='bars' onClick={() => setVisible(!(visible))} />
                    <img style={{ width: '130px' }} src={require('../../assets/images/logo.png')} alt="logo" />
                    <span style={{ color: "#606c76", marginLeft: '10px' }}> | {'TIME ADMIN CONSOLE'}</span>
                </div>
                <div className="Main-page_content" >
                    {/* <a link="#" className="menu-btn" role="button">
                        <Icon name="bell outline" />
                    </a> */}
                    <img className="ui avatar image" src={require('../../assets/images/avatar.png')} alt="avatar" />
                    <div className="userName">
                        <label className="userFirstName">{props.user.roleName}</label>
                        <label className="locationName">{props.user.userName}</label>
                    </div>
                    <Dropdown className="dropdownScale" trigger={<a link="#" className="menu-btn" role="button"><Icon name="power off" /></a>}>
                        <Dropdown.Menu className="dropdownvisible">
                            <Dropdown.Item className="dropdownhoverfunc" text={
                                <Card>
                                    <Card.Content>
                                        <Card.Header className="headerImage">
                                            <a link="#" className="menu-btn">
                                                <Icon name="user" className="AdminIcon" />
                                            </a>
                                        </Card.Header>
                                        <Feed>
                                            <Feed.Event>
                                                <Feed.Content>
                                                    <Feed.Summary className="Feed_content-color">{props.user.userName}</Feed.Summary>
                                                    <Feed.Summary className="Feed_content-first">{props.user.roleName}</Feed.Summary>
                                                </Feed.Content>
                                            </Feed.Event>
                                        </Feed>
                                    </Card.Content>
                                    <Divider />
                                    <Card.Content>
                                        <Feed>
                                            <Feed.Event>
                                                <Feed.Content>
                                                    <Feed.Summary className="Feed_content-second">
                                                        <Button primary size="mini" onClick={handleLogout} >Logout</Button>
                                                    </Feed.Summary>
                                                </Feed.Content>
                                            </Feed.Event>
                                        </Feed>
                                    </Card.Content>
                                </Card>
                            }
                            />
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Header>
            <Sidebar.Pushable as={Segment}>
                <Sidebar basic="true" className="sideBar" as={Menu} animation={'overlay'} vertical visible={visible} direction='left'>
                    {/* <Menu.Item className="menu-name">
                        <Icon name="qrcode" /> <span>Dashboard</span>
                    </Menu.Item> */}
                    <div className='sidabarMenuList' style={{ overflow: 'auto', height: 'calc(100vh - 135px)', paddingBottom: '40px' }}>
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.SECURITY_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/Security'>
                                <Icon name="shield alternate" />
                                <span>Security</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.PROJECT_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/Projects'>
                                <Icon name="file alternate outline" />
                                <span>Projects</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.EMPLOYEE_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/Employee'>
                                <Icon name="user outline" />
                                <span>Employees</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.TIMECARD_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/TimeCard'>
                                <Icon name="clock outline" />
                                <span>Timecards</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.DEVICE_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/Devices'>
                                <Icon name="mobile alternate" />
                                <span>Devices</span>
                            </Menu.Item>
                        }
                        <hr />
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.REPORT_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/Report'>
                                <Icon name="ellipsis horizontal" />
                                <span>Reports</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.SECURITY_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/DivisionPage'>
                                <Icon name="disk" />
                                <span>Divisions</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.FORECAST_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name" to='/ForeCast'>
                                <Icon name="mixcloud" />
                                <span>Forecast</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.PAYROLLNOTEOPTION_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name payRollMenu" to='/PayRollNoteOptionPage'>
                                <span className="iconify" data-icon="mdi-file-edit-outline" data-inline="false"></span>
                                <span>Payroll Note List</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.EQUIPMENTLIST_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name payRollMenu" to='/EquipmentListPage'>
                                <span className="iconify" data-icon="material-symbols:forklift-outline" data-inline="false"></span>
                                <span>Equipment List</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.MATERIALLIST_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name payRollMenu" to='/MaterialListPage'>
                                <span className="iconify" data-icon="mdi:ellipse-outline" data-inline="false"></span>
                                <span>Material List</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.STATUSCODELIST_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name payRollMenu" to='/StatusCodeListPage'>
                                <span className="iconify chargerOutline" data-icon="material-symbols:charger-outline" data-inline="false"></span>
                                <span>Status Code List</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.TMVOUCHER_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name payRollMenu" to='/TMVoucher'>
                                <span className="iconify" data-icon="heroicons:ticket" data-inline="false"></span>
                                <span>T&M Voucher</span>
                            </Menu.Item>
                        }
                        {
                            props.user.claimValue.includes(Constants.MENU_CLAIMS.SUPERVISOROVERRIDEREASONLIST_MENU) &&
                            <Menu.Item as={NavLink} className="menu-name payRollMenu" to='/SupervisorOverrideReason'>
                                <span className="iconify" data-icon="mdi:rectangle-outline" data-inline="false"></span>
                                <span>Override Reason List</span>
                            </Menu.Item>
                        }
                    </div>
                    <div className="logOutPack">
                        <Button primary size="mini" onClick={handleLogout}>Logout</Button>
                        <label className="versionName">Version {packageJson.version}</label>
                    </div>
                </Sidebar>
                <Sidebar.Pusher>
                    <Segment className="cardSegment">
                        <Card className="cardSticky">
                            <div className="cardHeader">
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.SECURITY_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/Security'>Security</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.PROJECT_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/Projects'>Projects</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.EMPLOYEE_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/Employee'>Employees</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.TIMECARD_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/TimeCard'>Timecards</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.DEVICE_MENU) && (props.user.roleName === Constants.SYSTEM_ADMIN || props.user.roleName === Constants.ADMIN_ROLE_NAME) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/Devices'>Devices</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.DEVICE_MENU) && (props.user.roleName === Constants.CONTRIBUTE || props.user.roleName === Constants.READ_ONLY) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/Devices'>Devices</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.REPORT_MENU) && (props.user.roleName === Constants.SYSTEM_ADMIN || props.user.roleName === Constants.ADMIN_ROLE_NAME || props.user.roleName === Constants.PROJECT_MANAGER) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/Report'>Reports</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.REPORT_MENU) && (props.user.roleName === Constants.CONTRIBUTE || props.user.roleName === Constants.READ_ONLY) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/Report'>Reports</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.SECURITY_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/DivisionPage'>Divisions</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.FORECAST_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/ForeCast'>Forecast</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.PAYROLLNOTEOPTION_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/PayRollNoteOptionPage'>Payroll Note List</Button>
                                }
                                {
                                    props.user.claimValue.includes(Constants.MENU_CLAIMS.TMVOUCHER_MENU) &&
                                    <Button as={NavLink} className="menu-name tiny" to='/TMVoucher'>T&M Voucher</Button>
                                }
                            </div>
                        </Card>
                        <div style={{ width: '100%' }}>{props.children}</div>
                    </Segment>
                </Sidebar.Pusher>
            </Sidebar.Pushable>
        </Fragment>
    );
};

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));

Layout.displayName = 'Layout';